// Copyright ©️ 2026 eVolve MEP, LLC

import { Navigate } from 'react-router';

import { moduleRoute } from 'app/Layout/NavBar/globalNavigationMenu';
import { useEvolveLocation } from 'components/Mantine/Navigation/useEvolveLocation';

/** Sends `/machine-client` links to Machine Control, keeping the query string. */
export const MachineClientRedirect = () => {
  const { search } = useEvolveLocation();
  return <Navigate replace to={{ pathname: `/${moduleRoute}/fabrication/machine-control`, search }} />;
};
